// utils/evidenciaPraceUtils.js

// Výpočet total s ohľadom na minimálne poplatky a položky
export function calculateEntryTotal(entry, services) {
  if (entry.itemCount && entry.service && services[entry.service]) {
    let total = entry.itemCount * services[entry.service];
    if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
      total += 15;
    }
    return total;
  }
  let total = entry.quantity * entry.unitPrice;
  if (entry.service === 'Žiadosť o vrátenie DPH zo zahraničia') {
    total += 15;
  }
  return total;
}

// Súčet total pre zoznam záznamov
export function calculateTotal(entries) {
  return entries.reduce((sum, entry) => sum + entry.total, 0);
}

// Získanie filtrovaných záznamov podľa firmy, mesiaca a vyfakturovania
export function getFilteredEntries(entries, selectedCompany, filterMonth, showInvoiced) {
  return entries.filter(entry => {
    if (selectedCompany && entry.companyName !== selectedCompany) return false;
    if (filterMonth && !entry.date.startsWith(filterMonth)) return false;
    if (!showInvoiced && entry.invoiced) return false;
    return true;
  });
}

// Normalizácia textu (malé písmená, bez diakritiky, trim)
export function normalizeText(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
        .replace(/[\u0000-\u000F]/g, '') // Odstráni diakritiku
    .trim();
}

// Kapitalizácia názvu firmy (všetko veľkými písmenami)
export function capitalizeCompanyName(text) {
  if (!text) return '';
  return text.trim().toUpperCase();
}
